export default __webpack_public_path__ + "static/media/Амирсай 229.2653a7d8.jpg";